import styled from '@emotion/styled'
import { IconBaseProps } from 'react-icons'
import { IoCloseOutline as Close } from 'react-icons/io5'
import { StyledHTMLElement } from 'shop/theme/types'

export const Name = styled.p(() => ({
  color: '#2A2A2A',
  margin: 0
}))

export const ellipsis = {
  textOverflow: 'ellipsis',
  overflow: 'hidden'
}

export const ModifierOptionGroupName = styled.span<StyledHTMLElement>(() => ({
  width: '100%',
  margin: 0
}))

export const Label = styled.p<
  StyledHTMLElement & {
    withEllipsis: boolean
    fontWeight?: number
    hasMargin?: boolean
  }
>(({ withEllipsis, fontWeight = 400, hasMargin }) => ({
  ...(withEllipsis && {
    ...ellipsis,
    whiteSpace: 'nowrap'
  }),
  fontWeight: fontWeight,
  ...(hasMargin && { margin: '0' })
}))

export const Clear = styled(Close)<
  IconBaseProps & {
    top: string
    position?: 'absolute' | 'initial'
  }
>(({ top, position = 'absolute' }) => ({
  right: '6px',
  flexShrink: 0,
  position: position,
  width: '22px',
  height: '22px',
  top: top,
  cursor: 'pointer',
  marginLeft: 'auto',

  '&:hover': {
    backgroundColor: '#0000000d',
    borderRadius: '28px'
  },
  '&:active': {
    backgroundColor: '#0000001a',
    borderRadius: '28px'
  }
}))
